import { type ReactNode } from 'react'
import { Box, Button, Link, Paper, Stack, Typography } from '@mui/material'
import { TitoloPagina } from '../layout/Pagina'
import { EMAIL_ASSISTENZA, URL_SITO } from '../lib/sito'

function Scheda({ titolo, children }: { titolo: string; children: ReactNode }) {
  return (
    <Paper variant="outlined" sx={{ p: 2.5 }}>
      <Typography variant="h6" component="h2" gutterBottom>{titolo}</Typography>
      {children}
    </Paper>
  )
}

export function Guide() {
  return (
    <Stack spacing={2.5}>
      <TitoloPagina titolo="Guide e tutorial" sottotitolo="Come compilare e inviare l'AD-1, scadenze e adempimenti, spiegati passo per passo." />
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
        <Scheda titolo="Guide">
          <Typography color="text.secondary" sx={{ mb: 2 }}>Dichiarazione annuale e semestrale, letture, firma e invio alle Dogane.</Typography>
          <Button variant="outlined" href={`${URL_SITO}/guide`} target="_blank" rel="noopener">Apri le guide</Button>
        </Scheda>
        <Scheda titolo="Domande frequenti">
          <Typography color="text.secondary" sx={{ mb: 2 }}>Le risposte rapide ai dubbi più comuni su accise, scadenze e portale.</Typography>
          <Button variant="outlined" href={`${URL_SITO}/faq`} target="_blank" rel="noopener">Apri le FAQ</Button>
        </Scheda>
      </Stack>
    </Stack>
  )
}

const FUNZIONI = [
  {
    titolo: 'Dichiarazioni AD-1',
    testo: 'Anagrafiche di aziende e impianti, contatori e letture, calcolo dei quadri con le regole fiscali dell\'anno, firma digitale, invio telematico alle Dogane, esito e ricevuta.',
  },
  { titolo: 'Scadenzario', testo: 'Tarature, SPI, ARERA, antimafia e scadenze personalizzate, con avviso prima della data.' },
  { titolo: 'Registri letture', testo: 'Registri per impianto pronti per la vidimazione, dalle letture già inserite.' },
  {
    titolo: 'PraticheEnergia Controllo Consumi',
    testo: 'Produzione, immissione e autoconsumo mese per mese dai portali dei gestori, confronto con l\'anno precedente e segnalazione degli scostamenti.',
  },
  { titolo: 'Email automatiche', testo: 'Promemoria e comunicazioni ai clienti dal tuo indirizzo, con modelli e storico degli invii.' },
  { titolo: 'Account e permessi', testo: 'Più operatori sullo stesso account, ciascuno con i propri permessi e i propri impianti.' },
]

export function Funzionalita() {
  return (
    <Stack spacing={2.5}>
      <TitoloPagina titolo="Funzionalità" sottotitolo="Cosa puoi fare con il portale." />
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2 }}>
        {FUNZIONI.map((f) => (
          <Scheda key={f.titolo} titolo={f.titolo}>
            <Typography color="text.secondary">{f.testo}</Typography>
          </Scheda>
        ))}
      </Box>
    </Stack>
  )
}

export function Assistenza() {
  return (
    <Stack spacing={2.5}>
      <TitoloPagina titolo="Assistenza" sottotitolo="Scrivici per dubbi sul portale, su una dichiarazione o su un invio." />
      <Scheda titolo="Contattaci">
        <Typography sx={{ mb: 2 }}>
          Email: <Link href={`mailto:${EMAIL_ASSISTENZA}`}>{EMAIL_ASSISTENZA}</Link>
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 2 }}>
          Indica il codice impianto e il periodo della dichiarazione: ci permette di risponderti senza chiederti altro.
        </Typography>
        <Button variant="outlined" href={`${URL_SITO}/contatti`} target="_blank" rel="noopener">Modulo di contatto</Button>
      </Scheda>
    </Stack>
  )
}
